import { EgretLoadable } from "egret";
import { withTranslation } from "react-i18next";
import ConstantList from "../../appConfig";
const Event = EgretLoadable({
  loader: () => import("./Event"),
});
const ViewComponent = withTranslation()(Event);
const EventRoutes = [
  {
    path: ConstantList.ROOT_PATH + "event",
    exact: true,
    component: ViewComponent,
  },
];

export default EventRoutes;
